import {VillageFeature} from '@/services/types';

export enum VillageRegion {
  Sicily = 1,
  Puglia = 2,
}

export interface IVilla {
  id: number;
  title: string;
  sleeps: number;
  bedrooms: number;
  bathrooms: number;
  infants: number;
  enabled: boolean;
  showPromotion: boolean;
  isNew: boolean;
  exclusive: boolean;
  videoUrl: string;
  city: string;
  categories: {
    id: number;
    code: string;
    enabled: boolean;
  };
  media: string;
  prices: {
    originalPrice: number;
    ownerPrice: number;
    currency: string;
  };
  zone: {
    code: string;
    enabled: boolean;
  };
  villageMainFeatures: VillageFeature[];
  slug: string;
}
